import { createContext, useContext } from 'react';

/**
 * This is the loading context
 */
const LoadingContext = createContext({
    loading: false,
    setLoading: null,
});

LoadingContext.displayName = 'Loading Context';

/**
 * Hook to use the global data context.
 * @returns {React.Context}
 */
const useLoading = () => useContext(LoadingContext);

export { LoadingContext, useLoading };
